import React from 'react';
import { motion } from 'framer-motion';

const FreeConsultation = () => {
  const handleCTAClick = () => {
    const el = document.getElementById('scheduling');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.location.href = '/#scheduling';
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="container mx-auto px-4 py-6"
    >
      <div className="bg-white/95 rounded-2xl shadow-md p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-left">
          <h3 className="text-2xl md:text-3xl font-semibold text-[#063127]">
            Quer entender como a TALC pode apoiar o crescimento do seu negócio?
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Agende uma consultoria gratuita e descubra oportunidades fiscais e contábeis.
          </p>
        </div>

        <div className="flex-shrink-0">
          <button
            onClick={handleCTAClick}
            className="inline-flex items-center gap-3 bg-[#c99b36] hover:bg-[#b0862b] text-white font-bold px-5 py-3 rounded-lg shadow-md transition"
            aria-label="Agendar consultoria gratuita"
          >
            Agendar consultoria gratuita &gt;
          </button>
        </div>
      </div>
    </motion.section>
  );
};

export default FreeConsultation;
